import { Flex } from '@mantine/core';

import { ConnectText, LogoStar, LogoStroke } from '@/shared/ui-kit/icons';
import { LogoFilled } from '@/shared/ui-kit/icons/LogoFilled';

import style from './LogoLoading.module.css';

export const LogoLoading = () => (
  <Flex direction='column'>
    <LogoFilled className={style.logoFilled} width={157} />
    <LogoStroke className={style.logo} width={157} />
    <div className={style.textIconContainer}>
      <ConnectText className={style.text} height={20} />
      <LogoStar className={style.icon} width={30} />
    </div>
  </Flex>
);
